// extracted by mini-css-extract-plugin
export var logo = "logo-module--logo--Hf9PO";
export var logoBlack = "logo-module--logoBlack--QjZiF";
export var sideText = "logo-module--sideText--ne4xp";